<template>
    <div class="service-box text-center">
        <span class="icon-box">
            <span class="fa">
                <img :src="image">
            </span>
            <svg version="1.1" id="Layer_1" xlmns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 -10 300 320" xml:space="preserve">
              <g>
              	<polygon points="22.3,223.7 22.3,76.3 150,2.5 277.7,76.3 277.7,223.7 150,297.5 	"></polygon>
              	<path d="M150,4.8l125.7,72.6v145.2L150,295.2L24.3,222.6V77.4L150,4.8 M150,0.2L20.3,75.1v149.8L150,299.8l129.7-74.9V75.1L150,0.2
              		L150,0.2z"></path>
              </g>
              </svg>
        </span>
        <h3>{{ title }}</h3>
        <p>{{ content }}</p>
        <hr class="underline"/>
    </div>
</template>
<script>
export default {
    props: ['title', 'content', 'image']
}
</script>
<style lang="scss">
    @import "src/assets/sass/shared.scss";

    .service-box{
        position: relative;
        margin-top: 40px;
        margin-bottom: 60px;
        border: 1px solid $secondary-color;
        @include prefixer(transition,all 0.3s ease-in-out,("moz","ms","webkit","o"));
        // @include prefixer(transition,box-shadow 0.3s ease-in-out,("moz","ms","webkit","o"));
        .icon-box{
            display: block;
            position: absolute;
            left: 50%;
            width: 30%;
            max-width: 80px;
            transform: translate(-50%, -50%);
            color:$secondary-color;
            @include prefixer(transform,translate(-50%,-50%),("moz","ms","webkit","o"));
            span.fa{
                position: absolute;
                top: 50%;
                left: 50%;
                @include prefixer(transform,translate(-50%,-50%),("moz","ms","webkit","o"));
                
            }
               svg {
                polygon{
                    fill:white;
                }
                path{
                    stroke-width:8px;
                    stroke:$secondary-color;
                    @include prefixer(transition,stroke 0.3s ease-in-out,("moz","ms","webkit","ms"));
                }
            }
        }
     h3{
         margin-top:60px;
         margin-bottom:20px;
     }
     p{
         padding:0px 10px;
         height: 80px;
         direction: rtl;
     }
     hr.underline{
         width:30%;
         margin:30px auto;
         border-top:2px solid $secondary-color;
     }

     &:hover{

         @include prefixer(transform,translateY(-10px),("moz","webkit","ms","o"));
         @include prefixer(box-shadow,0px 7px 10px 1px rgba(84, 84, 84, 0.5),("moz","o","webkit","ms"));

         svg{
             path{
                 stroke:$main-color;
                    @include prefixer(transition,stroke 0.3s ease-in-out,("moz","ms","webkit","ms"));
                 
             }
         }
     }
    }
</style>



// WEBPACK FOOTER //
// src/components/home/service-box.vue